import { HintsComponent } from './hints.component';

export const Hints = HintsComponent;